import { Action } from '@ngrx/store';
import { IStatusPointsModel } from '../../models/loyalty/IStatus-Points.model';

// @loyaltyDocs: Getting status points from Amadeus+Me
// (triggers Java API)
export const GET_STATUS_POINTS = '[StatusPoints] Get Status Points';
export const GET_STATUS_POINTS_SUCCESS = '[StatusPoints] Get Status Points Success';
export const GET_STATUS_POINTS_ERROR = '[StatusPoints] Get Status Points Error';

// Actions for Getting Status points
export class GetStatusPoints implements Action {
  readonly type = GET_STATUS_POINTS;
  constructor(public payload: any) {}
}

export class GetStatusPointsSuccess implements Action {
  readonly type = GET_STATUS_POINTS_SUCCESS;
  constructor(public payload: IStatusPointsModel) {}
}

export class GetStatusPointsError implements Action {
  readonly type = GET_STATUS_POINTS_ERROR;
  constructor(public payload: string) {}
}

export type StatusPointsActions = GetStatusPoints | GetStatusPointsSuccess | GetStatusPointsError;
